<form #createPlanoForm="ngForm">
    <app-custom-modal #modal [title]="'Conceder status VIP'"
        [subtitle]="'Tem certeza que deseja conceder acesso VIP a este paciente? Apenas médicos autorizados pela clínica poderão acessar o prontuário dele.'"
        (onCloseClick)="modal.close()" (onSaveClick)="save()" [saveLabel]="'Sim, conceder status VIP  →'" hideCancel
        [saveDisabled]="createPlanoForm.invalid">
        <div class="container">

            <div class="row">
                <div class="col-auto d-flex justify-content-center align-items-center">
                    <div class="user-foto-container">
                        <img src="../../../../../../assets/img/user.png" alt="Foto do usuário">
                    </div>
                </div>
                <div class="col d-flex flex-column justify-content-center ">
                    <p class="font-primary-gray-900">{{paciente.nome}}</p>
                    <p class="color-grey d-flex align-items-center">
                        <i class="hgi hgi-stroke hgi-identity-card color-grey mr-2"></i>
                        {{paciente.nome}}
                    </p>
                    <p class="color-grey d-flex align-items-center">
                        <i class="hgi hgi-stroke hgi-mail-01 color-grey mr-2"></i>
                        {{paciente.email}}
                        </p>
                    <p *ngIf="paciente.dataNascimento" class="color-grey d-flex align-items-center">
                        <i class="hgi hgi-stroke hgi-birthday-cake color-grey mr-2"></i>
                        {{getIdade()}}
                    </p>
                    <p *ngIf="paciente.sexoDescricao" class="color-grey d-flex align-items-center">
                        <i class="hgi hgi-stroke hgi-location-user-01 color-grey mr-2"></i>
                        {{paciente.sexoDescricao}}
                    </p>
                </div>
            </div>
        </div>
    </app-custom-modal>
</form>